/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

export const METRIC_STATS_RANGES = {
  daily: 'DAILY',
  hourly: 'HOURLY',
  monthly: 'MONTHLY',
  yearly: 'YEARLY',
} as const;

export const METRIC_STATS_TYPES = {
  avgCacheRatio: 'AVG_CACHE_RATIO',
  avgHttpError: 'AVG_HTTP_ERROR_RATE',
  avgPageLoadTime: 'AVG_PAGE_LOAD_TIME',
  cacheRatio: 'CACHE_RATIO',
  fileSize: 'FILE_SIZE',
  httpStatus404: 'HTTP_STATUS_404',
  pageLoadTime: 'PAGE_LOAD_TIME',
  pageViews: 'PAGE_VIEWS',
  summaryPageViews: 'SUMMARY_PAGE_VIEWS',
  timeSeriesHttp404Errors: 'TIME_SERIES_SUMMARY_HTTP_STATUS_404',
  timeSeriesPageViews: 'TIME_SERIES_SUMMARY_PAGE_VIEWS',
} as const;

export type MetricStatsTypes = typeof METRIC_STATS_TYPES;
export type MetricStatsRanges = typeof METRIC_STATS_RANGES;
export type MetricStatDataUnit = 'ms' | 'count' | 'bytes' | 'ratio';

export type LoadTimeStat = {
  requests: MetricStatValue;
  bandwidth: MetricStatValue;
  avg: MetricStatValue;
  p95: MetricStatValue;
  path?: string;
};

export type HttpStatus404Stat = {
  httpStatus404: MetricStatValue;
  path?: string;
};

export type CacheRatioStat = {
  requests: MetricStatValue;
  ratio: MetricStatValue;
  path?: string;
};

export type FileSizeStat = {
  requests: MetricStatValue;
  fileSize: MetricStatValue;
  bandwidth: MetricStatValue;
  path?: string;
};

export type PageViewsStat = {
  pageViews: MetricStatValue;
  path?: string;
};

export type MetricStatTimeSeries<T extends MetricStatDataUnit, Y extends Exclude<unknown, null | undefined>> = {
  unit: T;
  data: Y;
  datetime: string;
};
export interface MetricStatValue {
  data: string;
  unit: MetricStatDataUnit;
}

export interface EntityMetricStatsItem {
  loadTime?: Array<LoadTimeStat>;
  httpStatus404?: Array<HttpStatus404Stat>;
  cacheRatio?: Array<CacheRatioStat>;
  avgLoadTime?: MetricStatValue;
  avgCacheRatio?: MetricStatValue;
  avgHttpErrorRate?: MetricStatValue;
  fileSize?: Array<FileSizeStat>;
  pageViews?: Array<PageViewsStat>;
  summaryPageViews?: MetricStatValue;
  timeSeriesSummaryHttpStatus404?: Array<MetricStatTimeSeries<'count', string>>;
  timeSeriesSummaryPageViews?: Array<MetricStatTimeSeries<'count', string>>;
}
